import { api } from './api';

// Stato condiviso dell'avviso fine asta: aste seguite + canali scelti.
let state = { loaded: false, keys: new Set(), channels: [], chosen: false, linked: false };
let pending = null;
let pendingFor = null;
const listeners = new Set();
const emit = () => listeners.forEach(fn => fn(state));

export const reminderKey = (l) => `${l.source}:${l.source_listing_id}`;

export function loadReminders(userId = null) {
  if (pending && pendingFor === userId) return pending;
  pendingFor = userId;
  pending = api.getAuctionReminders()
    .then(d => {
      state = {
        loaded: true,
        keys: new Set((d.watches || []).map(reminderKey)),
        channels: d.channels || [],
        chosen: !!d.channels_chosen,
        linked: !!d.telegram_linked,
      };
      emit();
      return state;
    })
    .catch(() => state);
  return pending;
}

export function subscribeReminders(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

export const getReminderState = () => state;

export async function followAuction(listing) {
  await api.followAuction(listing.source, listing.source_listing_id);
  state = { ...state, keys: new Set(state.keys).add(reminderKey(listing)) };
  emit();
}

export async function unfollowAuction(listing) {
  await api.unfollowAuction(listing.source, listing.source_listing_id);
  const keys = new Set(state.keys);
  keys.delete(reminderKey(listing));
  state = { ...state, keys };
  emit();
}

export async function saveReminderChannels(channels) {
  const d = await api.setAuctionReminderChannels(channels);
  state = { ...state, channels: d.channels, chosen: true };
  emit();
}

export function setReminderLinked(linked) {
  if (state.linked === linked) return;
  state = { ...state, linked };
  emit();
}
